/* eslint-disable prettier/prettier */
import layouts from '@layouts/index';
import { commonRoutes } from '@pages/common/routes';
import { book } from '@routes/book';
import { AppRoute } from '@setup/typedefs';
import React, { lazy } from 'react';

const ForgotPasswordPage = lazy(()=> import('@pages/public/ForgotPasswordPage'));
const ResetPasswordPage = lazy(()=> import('@pages/public/ResetPasswordPage'));
const SignInPage = lazy(()=> import('@pages/public/SignInPage'));
const SignUpPage = lazy(()=> import('@pages/public/SignUpPage'));

const EmailVerificationPage = lazy(()=>import('@pages/public/EmailVerificationPage'));const SuccessForgotEmailPage = lazy(()=>import('@pages/public/SuccessForgotEmailPage'));const SuccessPasswordResetPage = lazy(()=>import('@pages/public/SuccessPasswordResetPage'));// IMPORTS
export const publicRoutes: AppRoute<any>[] = [
  ...[
    {
      path: `${book.signIn}`,
      Component: <SignInPage />,
      Layout: layouts.AuthLayout,
      layoutProps: {},
    },
    {
      path: `${book.signUp}`,
      Component: <SignUpPage />,
      Layout: layouts.AuthLayout,
      layoutProps: {},
    },
    {
      path: `${book.signUp}/:coupon/`,
      Component: <SignUpPage />,
      Layout: layouts.AuthLayout,
      layoutProps: {},
    },
    {
      path: book.forgotPassword,
      Component: <ForgotPasswordPage />,
      Layout: layouts.AuthLayout,
      layoutProps: {},
    },
    {
      path: `${book.resetPassword}/:user_id/:reset_token`,
      Component: <ResetPasswordPage />,
      Layout: layouts.AuthLayout,
      layoutProps: {},
    },
    {
      path: `${book.emailVerification}`,
      Component: <EmailVerificationPage />,
      Layout: layouts.AuthLayout,
      layoutProps: {},
    },
    {
      path: `${book.successForgotEmail}`,
      Component: <SuccessForgotEmailPage />,
      Layout: layouts.AuthLayout,
      layoutProps: {},
    },
    {
      path: `${book.successPasswordReset }`,
      Component: <SuccessPasswordResetPage />,
      Layout: layouts.AuthLayout,
      layoutProps: {},
    },// INJECT
  ],
  ...commonRoutes,
];
